import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: apiUrl,
});

// Intercepteur pour ajouter le token JWT à chaque requête
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      console.warn("Token JWT manquant");
      return;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs globales (comme un token expiré)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.error || error.message;

    if (status === 401 && message.toLowerCase().includes("token")) {
      console.warn("Token expiré ou invalide, redirection vers login");
      localStorage.removeItem("jwtToken");
      window.location.href = "/Login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
